"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "list-romaneio"
  }, [_c("RomaneioTable", {
    attrs: {
      data: _vm.listRomaneio,
      "is-loading": _vm.isLoading
    }
  }), _vm._v(" "), _c("b-pagination", {
    staticClass: "mt-4",
    attrs: {
      total: _vm.meta.total,
      current: _vm.meta.currentPage,
      "per-page": _vm.meta.perPage,
      "range-before": "2",
      "range-after": "2",
      size: "is-small",
      order: "is-centered"
    },
    on: {
      "update:current": function updateCurrent($event) {
        return _vm.$set(_vm.meta, "currentPage", $event);
      },
      change: _vm.handlePageChange
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;